module.exports = __webpack_public_path__ + "static/img/f-step4.aa3a2df3.png";